<style scoped>
    .container{
        position: relative;
    }
    .relation-container{
        width: 100%;
        overflow: auto;
        white-space: nowrap;
    }
    .relation-wrap{
        white-space: nowrap;
        border-top: 1px solid #dddee1;
        margin-top: 5px;
    }
    .relation-item{
        display: inline-block;
        vertical-align: top;
        border: 1px solid #dddee1;
        padding-top: 5px;
        margin: 5px 2px;
        text-align: center;
    }
</style>
<template>
  <div class="container">
    <div class="relation-container">
      <div
        v-for="group in fin_team_groups"
        :key="group.id"
        class="relation-item"
      >
        <GroupEdit
          :fin_team_group="group"
          @update="getTeamAndGroup"
        />
        <div
          v-if="group.children.length"
          class="relation-wrap"
        >
          <div
            v-for="fin_team in group.children"
            :key="fin_team.id"
            class="relation-item"
          >
            <FinTeamEdit
              :fin_team="fin_team"
              :fin_team_groups="fin_team_groups"
              @update="getTeamAndGroup"
            />
            <div
              v-if="fin_team.children.length"
              class="relation-wrap"
            >
              <TeamEdit
                v-for="team in fin_team.children"
                :key="team.id"
                :team="team"
                :fin_teams="fin_teams"
                @update="getTeamAndGroup"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="fin_team in fin_teams"
        v-if="!fin_team.group_id && fin_team.is_virtual"
        :key="fin_team.id"
        class="relation-item"
      >
        <FinTeamEdit
          :fin_team="fin_team"
          :fin_team_groups="fin_team_groups"
          @update="getTeamAndGroup"
        />
        <div class="relation-wrap">
          <TeamEdit
            v-for="team in fin_team.children"
            :key="team.id"
            :team="team"
            :fin_teams="fin_teams"
            @update="getTeamAndGroup"
          />
        </div>
      </div>
    </div>
    <div class="hr" />
    <Row>
      <i-col span="8">
        <h3>
          区域划分 <GroupEdit
            :fin_team_group="{}"
            @update="getTeamAndGroup"
          />
        </h3>
        <div class="line">
          <GroupEdit
            v-for="group in fin_team_groups"
            v-if="group.children.length === 0"
            :key="group.id"
            :fin_team_group="group"
            @update="getTeamAndGroup"
          />
        </div>
      </i-col>
      <i-col span="8">
        <h3>
          项目(财务纬度) <FinTeamEdit
            :fin_team="{}"
            :fin_team_groups="fin_team_groups"
            @update="getTeamAndGroup"
          />
        </h3>
        <div class="line">
          <FinTeamEdit
            v-for="team in fin_teams"
            v-if="team.group_id === 0 && !team.is_virtual"
            :key="team.id"
            :fin_team="team"
            :fin_team_groups="fin_team_groups"
            @update="getTeamAndGroup"
          />
        </div>
      </i-col>
      <i-col span="8">
        <h3>项目(员工纬度)</h3>
        <div class="line">
          <TeamEdit
            v-for="team in teams"
            v-if="team.fin_team_id === 0"
            :key="team.id"
            :team="team"
            :fin_teams="fin_teams"
            @update="getTeamAndGroup"
          />
        </div>
      </i-col>
    </Row>
    <Spin
      v-if="loading"
      fix
    />
  </div>
</template>
<script route="/fin_report_v2/setting/fin_team">
  import GroupEdit from './components/fin_team_group_edit';
  import FinTeamEdit from './components/fin_team_edit';
  import TeamEdit from './components/team_edit';
  export default {
    /* router_info_start */
    router_info: '/fin_report_v2/setting/fin_team',
    /* router_info_end */

    components: { GroupEdit, FinTeamEdit, TeamEdit },
    data() {
      return {
        teams: [],
        fin_teams: [],
        fin_team_groups: [],
        loading: false,
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      this.getTeamAndGroup();
    },
    methods: {
      getTeamAndGroup() {
        this.teams = [];
        this.fin_teams = [];
        this.fin_team_groups = [];
        this.loading = true;
        Util.ajax.get(Util.api.get_fin_team_and_group).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            this.teams = data.teams;
            data.fin_teams.forEach((fin_team) => {
              fin_team.children = [];
              this.fin_teams.push(fin_team);
            });
            data.fin_team_groups.forEach((group) => {
              group.children = [];
              this.fin_team_groups.push(group);
            });
            this.genRelation();
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      genRelation() {
        const fin_team_group_hash = {};
        const fin_team_hash = {};
        this.fin_team_groups.forEach((group) => {
          fin_team_group_hash[group.id] = group;
        });
        this.fin_teams.forEach((fin_team) => {
          fin_team_hash[fin_team.id] = fin_team;
          const group = fin_team_group_hash[fin_team.group_id];
          group && group.children.push(fin_team);
        });
        this.teams.forEach((team) => {
          const fin_team = fin_team_hash[team.fin_team_id];
          fin_team && fin_team.children.push(team);
        });
      },
      updateFinTeamGroup(group) {
        Util.insertOrUpdateArrayItem(this.fin_team_groups, group);
      }
    }
  }
</script>
